$(document).ready(function() {
  

  var isMobile = mwLibs.isMobileFun() // true 移动/ false PC

  var lisType = 'list'
  
  $('#listBtn').on('click', function(e) {
    if (lisType === 'list') return
    $('#capturePicMode').hide()
    $('#captureListMode').show()
    lisType = 'list'
    $('#listBtn').addClass('active')
    $('#picBtn').removeClass('active')

    if (isMobile) {
      $('#listBtn').hide()
      $('#picBtn').show()
    }
  })


  $('#picBtn').on('click', function(e) {
    if (lisType === 'pic') return
    $('#captureListMode').hide()
    $('#capturePicMode').show()
    lisType = 'pic'
    $('#picBtn').addClass('active')
    $('#listBtn').removeClass('active')

    if (isMobile) {
      $('#picBtn').hide()
      $('#listBtn').show()
    }
  })
    
  // 初始化分页功能
  mwLibs.paginationUtils.initPagination();


  if (isMobile) {
    $('item-btn').hide()

    if (lisType === 'list') {
      $('#listBtn').hide()
      $('#picBtn').show()
    } else {
      $('#picBtn').hide()
      $('#listBtn').show()
    }

  } else {
    $('item-btn').show()
  }


    // 初始化移动端点击事件
    function initMobileClickEvents(isMobile) {
      $('#captureList tr').off('click.mobile');
      $('#itemList li').off('click.mobile');

      if (isMobile) {
        $('.item-btn').hide()

        $('#captureList tr').on('click.mobile', function() {
          const url = $(this).data('url');
          if (url) window.location.href = url;
        });
        $('#itemList li').on('click.mobile', function() {
          const url = $(this).data('url');
          if (url) window.location.href = url;
        });

      } else {
        $('.item-btn').show()
      }
    }
    
    // 初始化
    initMobileClickEvents(isMobile);


    const newsSwiper = new Swiper('.frame-grabber-swiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.frame-swiper-pagination',
        clickable: true,
      },
      on: {
        init() {
        }
      },
    });

    // 默认隐藏详情区域
    const $slides = $('.frame-grabber-container .swiper-slide');
    $slides.find('.text-intro-detail').hide();
    $slides.find('.img-intro-detail').show();

    // 展开详情
    $(document).on('click.frameDetail', '.frame-grabber-container .more-content-btn', function(e) {
      e.preventDefault();
      console.log('11111')
      const $slide = $(this).closest('.swiper-slide');
      $slide.find('.img-intro-detail').hide();
      $slide.find('.text-intro-detail').show();
    });

    // 收起详情
    $(document).on('click.frameDetail', '.frame-grabber-container .close-content-btn', function(e) {
      e.preventDefault();
      const $slide = $(this).closest('.swiper-slide');
      $slide.find('.text-intro-detail').hide();
      $slide.find('.img-intro-detail').show();
    });

    // newsSwiper() 似乎意外调用，已无需执行
});
